import { render, staticRenderFns } from "./otherBenefits.vue?vue&type=template&id=3944d7b8&scoped=true"
import script from "./otherBenefits.vue?vue&type=script&lang=js"
export * from "./otherBenefits.vue?vue&type=script&lang=js"
import style0 from "./otherBenefits.vue?vue&type=style&index=0&id=3944d7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944d7b8",
  null
  
)

export default component.exports